export default __webpack_public_path__ + "static/media/trusted ecosystem (1).de922896.svg";